import { Link } from "@tanstack/react-router";
import { t } from "i18next";
import { Trans, useTranslation } from "react-i18next";
import { FaXmark } from "react-icons/fa6";
import { FiExternalLink } from "react-icons/fi";

import { SvButton } from "@/components";
import { useBannerStore } from "@/stores/bannerStore.ts";

export const SvGlobalBanner = () => {
  const { isHidden, setHidden } = useBannerStore();
  const { i18n } = useTranslation();

  return (
    !isHidden && (
      <div className="bg-neon-yellow text-dark relative min-h-16 py-4 text-center">
        <div className="@container mr-20 ml-10 flex h-full flex-col items-center justify-between gap-4 md:flex-row md:gap-6 lg:justify-start lg:gap-8">
          <p className="text-left text-lg font-semibold">
            <Trans i18nKey="banner.message" />
          </p>

          <div className="flex w-full shrink-0 flex-col items-center justify-center gap-2.5 @sm:w-auto @sm:flex-row">
            <SvButton color="neutral" className="hidden w-auto lg:block">
              <Link
                to="/ridings/$election"
                params={{ election: "federal-2025" }}>
                {t("banner.cta1")}
              </Link>
            </SvButton>

            <SvButton
              color="neutral"
              variant="outline"
              iconRight={<FiExternalLink />}
              className="w-full @sm:w-auto">
              <a
                href={`https://www.elections.ca/content2.aspx?section=vote&document=index&lang=${i18n.language.startsWith("fr") ? "f" : "e"}`}
                target="_blank"
                rel="noreferrer">
                {t("banner.cta2")}
              </a>
            </SvButton>
          </div>
        </div>

        <FaXmark
          className="text-dark absolute top-1/2 right-10 ml-auto -translate-y-1/2 cursor-pointer text-2xl"
          onClick={() => setHidden(true)}
        />
      </div>
    )
  );
};
